import { TableColumnType, TableLocalStorageConfig, TableState } from "components/UI/Table/types/table.ts";
import { TableId } from "types/models.ts";

export const TABLES_CONFIG_LOCAL_STORAGE_ITEM_ID = `tablesConfig`;

export const clearAllTableConfigs = (): void => {
    Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("tableConfig-")) {
            localStorage.removeItem(key);
        }
    });
    localStorage.removeItem(TABLES_CONFIG_LOCAL_STORAGE_ITEM_ID);
};

// TODO: Maybe could be refactored into a class? No stateful logic, just utility functions (would allow usage outside of React components)
export const useTableLocalStorage = <T extends object>(tableId?: TableId) => {
    const getAllLocalStorageConfigs = (): Array<TableLocalStorageConfig<T>[]> | [] => {
        const config = localStorage.getItem(TABLES_CONFIG_LOCAL_STORAGE_ITEM_ID);
        return config ? JSON.parse(config) : [];
    };

    const getLocalStorageConfig = (): TableLocalStorageConfig<T> | null => {
        const configs = getAllLocalStorageConfigs();
        const configForTable = configs?.find((config) => Object.keys(config)[0] === tableId);
        // @ts-expect-error - TODO: Type 'undefined' cannot be used as an index type
        return configForTable ? configForTable[tableId] : null;
    };

    const setLocalStorageConfig = (config: TableLocalStorageConfig<T>): void => {
        const currentConfigs = getAllLocalStorageConfigs() || [];
        // @ts-expect-error - TODO: Type 'undefined' cannot be used as an index type
        const existingConfig = currentConfigs.find((config) => config[tableId]);

        if (existingConfig) {
            // @ts-expect-error - TODO: Type 'undefined' cannot be used as an index type
            existingConfig[tableId] = config;
        } else {
            // @ts-expect-error to refactor whole table
            currentConfigs.push({ [tableId]: config });
        }
        localStorage.setItem(TABLES_CONFIG_LOCAL_STORAGE_ITEM_ID, JSON.stringify(currentConfigs));
    };

    const setDefaultLocalStorageConfig = (columns: TableColumnType<T>[]): TableLocalStorageConfig<T> => {
        const defaultConfig: TableLocalStorageConfig<T> = {
            columnsConfig: columns.map((column, index) => ({
                dataIndex: column.dataIndex,
                visible: column.visible ?? true,
                order: index + 1,
            })),
        };
        //setLocalStorageConfig(defaultConfig); TEMP dont use localstorage config until refactor
        return defaultConfig;
    };

    const getTableStateWithConfig = (tableState: TableState<T>, columnConfig: TableColumnType<T>[]) => {
        const defaultConfig = setDefaultLocalStorageConfig(columnConfig);
        //TEMP dont use localstorage config until refactor
        return {
            ...tableState,
            config: defaultConfig,
            columns: columnConfig,
            originColumns: columnConfig,
        };
        /* const localStorageConfig = getLocalStorageConfig();
        if (!localStorageConfig) {
            const defaultConfig = setDefaultLocalStorageConfig(columnConfig);
            tableState = {
                ...tableState,
                config: defaultConfig,
                columns: columnConfig,
                originColumns: columnConfig,
            };
        } else {
            tableState = {
                ...tableState,
                config: localStorageConfig,
                columns: columnConfig,
                originColumns: columnConfig,
            };
        }
        return tableState;*/
    };

    return {
        setLocalStorageConfig,
        getLocalStorageConfig,
        getTableStateWithConfig,
        clearAllTableConfigs,
    };
};
